import { DEFAULT_PIEVE_SANS_FONT_SIZE_PX, DEFAULT_GENERAL_OPEN_DESTINATION_OPTIONS, GENERAL_OPEN_DESTINATION_VALUES, GENERAL_THREAD_DETAIL_OPTIONS, GENERAL_THREAD_DETAIL_VALUES, PERSONALIZATION_PERSONALITY_VALUES, PERSONALIZATION_PREFERRED_RESPONSE_LANGUAGE_OPTIONS, PERSONALIZATION_PREFERRED_RESPONSE_LANGUAGE_VALUES, getPieveUiScale, getDefaultPieveSettings, getNextPieveAutoThemeChangeDelayMs, getResolvedPieveTheme, mergePieveSettings, normalizePieveSettings } from '@shared/utils';

export { DEFAULT_PIEVE_SANS_FONT_SIZE_PX, DEFAULT_GENERAL_OPEN_DESTINATION_OPTIONS, GENERAL_OPEN_DESTINATION_VALUES, GENERAL_THREAD_DETAIL_OPTIONS, GENERAL_THREAD_DETAIL_VALUES, PERSONALIZATION_PERSONALITY_VALUES, PERSONALIZATION_PREFERRED_RESPONSE_LANGUAGE_OPTIONS, PERSONALIZATION_PREFERRED_RESPONSE_LANGUAGE_VALUES, getPieveUiScale, getNextPieveAutoThemeChangeDelayMs };

export const getDefaultPieveAppSettings = () => {
  return getDefaultPieveSettings();
};

export const normalizePieveAppSettings = (settings) => {
  return normalizePieveSettings(settings);
};

export const mergePieveAppSettings = ({ current, patch }) => {
  return mergePieveSettings({
    current,
    patch
  });
};

export const getResolvedTheme = (themeSetting, options) => {
  return getResolvedPieveTheme(themeSetting, options);
};
